import React, { CSSProperties, useContext } from "react";
import cn from "classnames";
import monday from "../tools/monday";

import { FunnelItem } from "../tools/treeFunnel";
import { Item } from "../types";

import styles from "./ItemRow.module.scss";
import { SettingsContext } from "../SettingsProvider";

interface Props {
    style: CSSProperties;
    index: number;
    funnelItem: FunnelItem;
    selectedLevel?: number;
    item: Item;
    trackedLabels: Set<string>;
    firstLabel?: string;
    lastLabel?: string;
    weight?: string;
}

const ItemRow: React.FC<Props> = function ({
    style,
    index,
    funnelItem,
    selectedLevel,
    item,
    trackedLabels,
    firstLabel,
    lastLabel,
    weight
}: Props) {
    const { labels } = useContext(SettingsContext);

    const handleItemClick = (): void => {
        monday.execute("openItemCard", { itemId: item.id });
    };

    return (
        <div className={styles.item} style={style}>
            <div className={styles.title} onClick={handleItemClick}>
                <div className={styles.titleText}>{item.name}</div>
            </div>
            {weight !== undefined && <div className={styles.weight}>{weight}</div>}
            <div className={styles.statuses}>
                {funnelItem.visitedLabels
                    .filter((label) => trackedLabels.has(label))
                    .map((label, idx) => {
                        const labelStyle = labels.labelsColors[label];
                        const selected = selectedLevel !== undefined && funnelItem.visitedLevels[idx] === selectedLevel;

                        return (
                            <div
                                key={`${idx}-${label}`}
                                className={cn(styles.status, { [styles.selected]: selected })}
                                style={{
                                    backgroundColor: selected ? labelStyle.color : labelStyle.colorInactive
                                }}
                            >
                                <div className={styles.statusText}>{labels.names[label]}</div>
                            </div>
                        );
                    })}
                {funnelItem.visitedLabels.length > 0 &&
                    lastLabel !== undefined &&
                    // eslint-disable-next-line eqeqeq
                    funnelItem.visitedLabels[funnelItem.visitedLabels.length - 1] != lastLabel && (
                        <div className={cn(styles.status, styles.empty)}>
                            <div className={styles.statusText}>x</div>
                        </div>
                    )}
            </div>
        </div>
    );
};

export default ItemRow;
